"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsApi = exports.AnalyticsApiFactory = exports.AnalyticsApiFp = exports.AnalyticsApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * AnalyticsApi - axios parameter creator
 */
const AnalyticsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Create a new analytics event
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsEventRequest} [analyticsCreateAnalyticsEventRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createAnalyticsEvent: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, userId, rHGApp, analyticsCreateAnalyticsEventRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsEvent', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsEvent', 'userId', userId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsEvent', 'rHGApp', rHGApp);
            const localVarPath = `/v1/analytics/users/{user_id}/action`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/analytics/users/{user_id}/action`,
                sdkMethod: 'createAnalyticsEvent',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(analyticsCreateAnalyticsEventRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Create a new analytics events
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsEventsRequest} [analyticsCreateAnalyticsEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnalyticsEvents: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, rHGApp, analyticsCreateAnalyticsEventsRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsEvents', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsEvents', 'recipientId', recipientId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsEvents', 'rHGApp', rHGApp);
            const localVarPath = `/v1/analytics/recipients/{recipient_id}/actions`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/analytics/recipients/{recipient_id}/actions`,
                sdkMethod: 'createAnalyticsEvents',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(analyticsCreateAnalyticsEventsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Emit a new streaming analytics events. This endpoint is used to emit events that are not stored in the database. The events are emitted to the streaming analytics system. Event name should be in snake_case. Event name will be used as the event type in the streaming analytics system.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsStreamEventsRequest} [analyticsCreateAnalyticsStreamEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnalyticsStreamEvents: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, rHGApp, analyticsCreateAnalyticsStreamEventsRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsStreamEvents', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsStreamEvents', 'recipientId', recipientId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsStreamEvents', 'rHGApp', rHGApp);
            const localVarPath = `/v1/analytics/recipients/{recipient_id}/stream/events`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/analytics/recipients/{recipient_id}/stream/events`,
                sdkMethod: 'createAnalyticsStreamEvents',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(analyticsCreateAnalyticsStreamEventsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AnalyticsApiAxiosParamCreator = AnalyticsApiAxiosParamCreator;
/**
 * AnalyticsApi - functional programming interface
 */
const AnalyticsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AnalyticsApiAxiosParamCreator)(configuration);
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Create a new analytics event
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsEventRequest} [analyticsCreateAnalyticsEventRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createAnalyticsEvent(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAnalyticsEvent(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AnalyticsApi.createAnalyticsEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Create a new analytics events
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsEventsRequest} [analyticsCreateAnalyticsEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnalyticsEvents(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAnalyticsEvents(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AnalyticsApi.createAnalyticsEvents']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Emit a new streaming analytics events. This endpoint is used to emit events that are not stored in the database. The events are emitted to the streaming analytics system. Event name should be in snake_case. Event name will be used as the event type in the streaming analytics system.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsStreamEventsRequest} [analyticsCreateAnalyticsStreamEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnalyticsStreamEvents(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAnalyticsStreamEvents(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AnalyticsApi.createAnalyticsStreamEvents']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.AnalyticsApiFp = AnalyticsApiFp;
/**
 * AnalyticsApi - factory interface
 */
const AnalyticsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AnalyticsApiFp)(configuration);
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Create a new analytics event
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsEventRequest} [analyticsCreateAnalyticsEventRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createAnalyticsEvent(params, options) {
            return localVarFp
                .createAnalyticsEvent(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Create a new analytics events
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsEventsRequest} [analyticsCreateAnalyticsEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnalyticsEvents(params, options) {
            return localVarFp
                .createAnalyticsEvents(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Emit a new streaming analytics events. This endpoint is used to emit events that are not stored in the database. The events are emitted to the streaming analytics system. Event name should be in snake_case. Event name will be used as the event type in the streaming analytics system.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsStreamEventsRequest} [analyticsCreateAnalyticsStreamEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnalyticsStreamEvents(params, options) {
            return localVarFp
                .createAnalyticsStreamEvents(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.AnalyticsApiFactory = AnalyticsApiFactory;
/**
 * AnalyticsApi - object-oriented interface
 */
class AnalyticsApi extends base_1.BaseAPI {
    /**
     * URL `/v1/analytics/users/{user_id}/action`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Create a new analytics event
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} userId User ID
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {AnalyticsCreateAnalyticsEventRequest} [analyticsCreateAnalyticsEventRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    createAnalyticsEvent(params, options) {
        return (0, exports.AnalyticsApiFp)(this.configuration)
            .createAnalyticsEvent(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/analytics/recipients/{recipient_id}/actions`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Create a new analytics events
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {AnalyticsCreateAnalyticsEventsRequest} [analyticsCreateAnalyticsEventsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAnalyticsEvents(params, options) {
        return (0, exports.AnalyticsApiFp)(this.configuration)
            .createAnalyticsEvents(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/analytics/recipients/{recipient_id}/stream/events`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Emit a new streaming analytics events. This endpoint is used to emit events that are not stored in the database. The events are emitted to the streaming analytics system. Event name should be in snake_case. Event name will be used as the event type in the streaming analytics system.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {AnalyticsCreateAnalyticsStreamEventsRequest} [analyticsCreateAnalyticsStreamEventsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAnalyticsStreamEvents(params, options) {
        return (0, exports.AnalyticsApiFp)(this.configuration)
            .createAnalyticsStreamEvents(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.AnalyticsApi = AnalyticsApi;
//# sourceMappingURL=analytics-api.js.map